import { Button } from '@argon';

export default Button;
